import { AfterViewInit, Component, computed, ElementRef, input, signal, viewChild } from '@angular/core';
import { clouds } from '../../mechanics/rid-fog-reading/assets';

@Component({
  selector: 'rid-fog',
  imports: [],
  templateUrl: './rid-fog.html',
  styleUrl: './rid-fog.css',
})
export class RidFog implements AfterViewInit {
  density = input.required<number>();
  stagger = input<number>(0);

  boxEl = viewChild.required<ElementRef<HTMLElement>>('box');
  bounds = signal({ width: 0, height: 0 });
  clouds = computed<{ src: string }[]>(() => {
    const count = this.bounds().width * this.density() * 0.005;
    return Array.from({ length: Math.ceil(count) }, () => ({ src: clouds[Math.floor(Math.random() * clouds.length)] }));
  });
  targets = signal<{ [index: number]: string }>({});

  ngAfterViewInit(): void {
    const observer = new ResizeObserver(([entry]) => {
      const { width, height } = entry.contentRect;
      this.bounds.set({ width, height });
    });

    observer.observe(this.boxEl().nativeElement);
  }

  chooseNextPosition(index: number) {
    this.targets.update((targets) => ({
      ...targets,
      [index]: this.getRandomPosition(),
    }));
  }

  getRandomPosition() {
    const angle = Math.random() * 2 * Math.PI;
    const distance = 80;
    const x = Math.cos(angle) * distance;
    const y = Math.sin(angle) * distance;
    return `translate(${x}%, ${y}%)`;
  }
}
